import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"

import { get } from "helpers/api_helper"
import KycOptionForm from "components/KycOptions/KycOptionForm"
import SpinnerLoader from "components/Loader/SpinnerLoader"
const EditKycOption = props => {
  const [kyc_option, setKycOption] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    get(`kyc-option/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setKycOption(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>KYC Options | GoFetchIt</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumb
          breadcrumb1={{ title: "KYC Options", href: "/kyc-options" }}
          breadcrumbItem="Add KYC Option"
        />
        {loading ? (
          <SpinnerLoader/>
        ) : (
          <KycOptionForm
            data={kyc_option}
            kyc_option_id={props.match.params.id}
          />
        )}
      </div>
    </div>
  )
}

export default EditKycOption
